import { form as constants } from "store/constants";
import {
    reduceIsFetching,
    reduceSetError,
    fetchableInitialState,
} from "store/factories/fetchable";

const initialState = {
    ...fetchableInitialState,
    content: {
        id: null, // id on proposal-feed-service
        modelId: null, // id on flowable
        version: null,
        formElements: [],
        formSections: [],
        rules: [],
        modelKey: "",
        lastPublishedFormElements: [],
    },
    entity: {
        ...fetchableInitialState,
        payloadRootContentKey: "",
        payloadContentType: "",
        // list of keys user changed manually
        changedFormKeys: new Set(),
        documentVersion: null,
        // proposal/award/subaward server response object
        data: {},
        formConfig: {},
        tabsConfig: {},
        // last saved form variables
        variables: {},
        // variables that user has changed
        changedVariables: {},
        requestsOptions: {
            get: null,
            update: null,
        },
        savingIndicator: false,
        isEditMode: false,
        isEditLocked: false,
        formTimeoutInfo: null,
    },
    rto: {
        effortFormat: sessionStorage.getItem("rtoEffortFormat") || null,
        members: [],
    },
};

export function form(state = initialState, action) {
    switch (action.type) {
        case constants.FORM_ENTITY_SET_INDICATOR_IS_SAVING:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    savingIndicator: action.payload,
                },
            };
        case constants.FORM_EDIT_MODE:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    isEditMode: action.payload,
                },
            };
        case constants.FORM_EDIT_LOCKED:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    isEditLocked: action.payload,
                },
            };

        case constants.FORM_ENTITY_CHANGED:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    isFormChanged: action.payload,
                },
            };

        case constants.FORM_TIMEOUT_INFO:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    formTimeoutInfo: action.payload,
                },
            };
        case constants.FORM_ENTITY_IS_FETCHING:
            return {
                ...state,
                entity: reduceIsFetching(state.entity, action),
            };
        case constants.FORM_ENTITY_SET_DATA: {
            return {
                ...state,
                entity: {
                    ...state.entity,
                    ...action.payload,
                },
            };
        }
        case constants.FORM_ENTITY_SET_ERROR: {
            return {
                ...state,
                entity: reduceSetError(state.entity, action),
            };
        }
        case constants.FORM_ENTITY_SET_CONTENT_KEYS: {
            return {
                ...state,
                entity: {
                    ...state.entity,
                    payloadRootContentKey: action.payload.payloadRootContentKey,
                    payloadContentType: action.payload.payloadContentType,
                },
            };
        }
        case constants.SET_ENTITY_FORM_REQUEST_OPTIONS: {
            return {
                ...state,
                entity: {
                    ...state.entity,
                    requestsOptions: action.payload,
                },
            };
        }
        case constants.FORM_ENTITY_SET_ENTITY_CHANGED_FORM_KEYS:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    changedFormKeys: action.payload,
                },
            };
        case constants.FORM_IS_FETCHING:
            return reduceIsFetching(state, action);
        case constants.FORM_SET_ERROR:
            return reduceSetError(state, action);
        case constants.FORM_SET_DATA:
            return {
                ...state,
                content: {
                    ...state.content,
                    ...action.payload,
                },
            };
        case constants.SET_RULES:
            return {
                ...state,
                content: {
                    ...state.content,
                    rules: action.payload,
                },
            };
        case constants.SET_EFFORT_FORMAT:
            sessionStorage.setItem("rtoEffortFormat", action.payload);

            return {
                ...state,
                rto: {
                    ...state.rto,
                    effortFormat: action.payload,
                },
            };
        case constants.SET_RTO_MEMBER_ASSOCIATION_DETAILS:
            return {
                ...state,
                rto: {
                    ...state.rto,
                    members: [...state.rto.members, action.payload],
                },
            };
        case constants.RESET:
            return {
                ...initialState,
                entity: {
                    ...initialState.entity,
                    documentVersion: state.entity.documentVersion,
                    editLock: state.entity.editLock,
                },
                rto: {
                    ...state.rto,
                    members: [],
                },
            };
        case constants.FORM_ENTITY_SET_FILE_UPLOADING:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    isFileUploading: action.payload,
                },
            };
        default:
            return state;
    }
}
